/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Create_TitleInputs */

const cs_property_create_title = /** @type {(inputs: Property_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová nemovitost`)
};

const en_property_create_title = /** @type {(inputs: Property_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New property`)
};

/**
* | output |
* | --- |
* | "New property" |
*
* @param {Property_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_create_title = /** @type {((inputs?: Property_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_create_title(inputs)
	return cs_property_create_title(inputs)
});